import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: ['Roboto Mono', 'monospace'],
  },
}));

/**
 * Table data listing
 *
 * Props:
 ** children: data to be wrapped around
 ** className: name of css class element
 */
const MonoText = (props) => {
  const { children, className, ...rest } = props;
  const classes = useStyles();

  return (
    <span {...rest} className={clsx(classes.root, className)}>
      {children}
    </span>
  );
};

export default MonoText;
